import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "../../../toast";
import { Modal, Table } from "flowbite-react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import ConformationModal from "./ConformationModal";
import { FaEye } from "react-icons/fa6";

const Question = ({ data, courseId, onDelete, catName, createdBy }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleDeleteClick = (event) => {
    event.stopPropagation();
    setIsConfirmationModalOpen(true);
  };

  const confirmDelete = () => {
    onDelete(data.id);
  };
    const user = JSON.parse(localStorage.getItem("user"));
 
    
    // const name = localStorage.getItem("userdisplayName")
    
    // console.log(user);
    // const userdisplayName = name || user?.displayName || user?.userdisplayName || "Unknown User";
    // console.log(userdisplayName );

  function getDifficultyColor(difficulty) {
    switch (difficulty) {
      case "EASY":
        return "bg-green-300 text-white";
      case "MEDIUM":
        return "bg-yellow-200 text-gray-800";
      case "HARD":
        return "bg-red-200 text-white";
      default:
        return "bg-gray-00 text-gray-800";
    }
  }

  const difficulty =
    data?.difficulty?.charAt(0).toUpperCase() +
    data?.difficulty?.slice(1).toLowerCase();

  return (
    <>
      <div className="relative cursor-pointer">
        <div className="flex justify-between mb-1 max-md:flex-col lg:items-center">
          
          {/* ✅ TITLE + DIFFICULTY SIDE BY SIDE */}
          <div
            onClick={openModal}
            className="flex items-center gap-2 text-xl font-bold hover:text-blue-500"
          >
            <span>{data?.title}</span>

            {data?.difficulty && (
              <span
                className={`px-2 py-[2px] text-[11px] font-light rounded-lg ${getDifficultyColor(
                  data.difficulty
                )}`}
              >
                {difficulty}
              </span>
            )}
          </div>

          {/* ACTION BUTTONS */}
          <div className="flex max-md:mt-3">
            <Link
              to={`/admin/courses/preview-question/${courseId}/${data.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaEye className="p-1 rounded-full h-7 w-7 hover:bg-secondary" />
            </Link>

            <Link to={`/admin/courses/${courseId}/edit-question/${data.id}`}>
              <MdModeEdit className="p-1 rounded-full h-7 w-7 hover:bg-blue-500" />
            </Link>

            <MdDelete
              onClick={handleDeleteClick}
              className="p-1 ml-2 rounded-full cursor-pointer h-7 w-7 hover:bg-red-500"
            />
          </div>
        </div>

        {/* DETAILS SECTION */}
        <div className="flex flex-col max-md:mt-3">
          <div className="mb-2">
            <p className="mb-2 text-sm text-gray-500">
              Category: {catName}, Max Score: {data.marks}
            </p>

            {/* CREATED BY */}
            <p className="text-sm text-gray-500">
              Created By:{" "}
              <span className="text-sm text-gray-500">
                {createdBy || "BT ADMIN"}
              </span>
            </p>
          </div>
          {/* TAGS */}
          <div className="flex flex-wrap gap-1">
            {data?.tags &&
              data.tags.map((tag, index) => (
                <span
                  key={index}
                  className="inline-block px-2 py-1 mt-4 text-xs font-medium text-blue-800 bg-blue-100 rounded"
                >
                  {tag}
                </span>
              ))}
          </div>
        </div>
      </div>

      {/* MODAL */}
      <Modal dismissible show={isModalOpen} onClose={closeModal}>
        <Modal.Header className="text-lg font-bold">
          {data.title}
        </Modal.Header>

        <Modal.Body>
          <div className="space-y-6">
            <p className="text-base text-gray-600">
              <span className="font-semibold text-black">Text:</span>
              <div dangerouslySetInnerHTML={{ __html: data.text }} />
            </p>

            <p className="text-base text-gray-600">
              <span className="font-semibold text-black">Course ID:</span>{" "}
              {data.course_id}
            </p>

            <p className="text-base text-gray-600">
              <span className="font-semibold text-black">Question Subtext:</span>
              <pre>{data.question_sub_text}</pre>
            </p>

            <p className="text-base text-gray-600">
              <span className="font-semibold text-black">Marks:</span>{" "}
              {data.marks}
            </p>

            {/* CREATED BY IN MODAL */}
            <p className="text-base text-gray-600">
              <span className="font-semibold text-black">Created By:</span>{" "}
              {createdBy || "BT ADMIN"}
            </p>

            {/* TEST CASES */}
            <div>
              <span className="font-semibold">Test Cases:</span>
              <Table className="w-full mt-2 border border-black">
                <Table.Head>
                  <Table.HeadCell className="px-4 py-2 border border-black">
                    Input
                  </Table.HeadCell>
                  <Table.HeadCell className="px-4 py-2 border border-black">
                    Output
                  </Table.HeadCell>
                  <Table.HeadCell className="px-4 py-2 border border-black">
                    Visibility
                  </Table.HeadCell>
                </Table.Head>

                <Table.Body>
                  {data.test_cases.map((testCase) => (
                    <Table.Row key={testCase.id}>
                      <Table.Cell className="px-4 py-2 border border-black">
                        <pre className="font-sans text-black">
                          {testCase.input}
                        </pre>
                      </Table.Cell>

                      <Table.Cell className="px-4 py-2 border border-black">
                        <pre className="font-sans text-black">
                          {testCase.output}
                        </pre>
                      </Table.Cell>

                      <Table.Cell className="px-4 py-2 border border-black">
                        <pre className="font-sans text-black">
                          {testCase.visibility}
                        </pre>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>

            {/* HINTS */}
            <div>
              {data.hints ? <span className="font-semibold">Hints:</span> : null}
              <ul>
                {data?.hints?.length !== 0
                  ? data.hints.map(
                      (hint, index) =>
                        hint.length > 0 && (
                          <li key={index} className="text-gray-500">
                            Hint {index + 1}: {hint}
                          </li>
                        )
                    )
                  : null}
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* CONFIRM DELETE MODAL */}
      <ConformationModal
        openModal={isConfirmationModalOpen}
        setOpenModal={setIsConfirmationModalOpen}
        event={confirmDelete}
        text="Are you sure you want to delete this question?"
      />
    </>
  );
};

export default Question;
